import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router-dom';

import Background from '../../components/layout/Background';
import Content from '../../components/layout/Content';
import Card from '../../components/ui/Card';

const Error = () => {
  const error: any = useRouteError();
  const { t } = useTranslation();

  return (
    <>
      <Content>
        <Card>
          <h1 style={{ marginBottom: '2em' }}>
            {t('errorPage.messageBegin')} {error.data.message}
          </h1>
          <Link to="/afterwork" relative="path">
            {t('errorPage.goBack')}
          </Link>
        </Card>
      </Content>
      <Background />
    </>
  );
};

export default Error;
